import { Controller } from "@hotwired/stimulus"

// "Verbindung zur Zeiterfassung" on the report type form: shows what belongs to the
// chosen mode (the template for "Bericht erzeugt Stundenzettel") and, when a type
// that booked timesheets is switched away from it, the question what happens to
// the open ones.
export default class extends Controller {
  static targets = ["mode", "section"]
  static values = { original: String }

  connect() {
    this.update()
  }

  update() {
    const selected = this.modeTargets.find((input) => input.checked)?.value
    this.sectionTargets.forEach((section) => {
      const shown =
        section.dataset.when === "leaving_books"
          ? this.originalValue === "books" && selected !== "books"
          : section.dataset.when === selected
      section.hidden = !shown
      section.querySelectorAll("input, select").forEach((input) => (input.disabled = !shown))
    })
  }
}
